import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = "MercadoTV - Sistemas de Videovigilância e Segurança em Portugal",
  description = "Especialistas em sistemas de videovigilância, alarmes Ajax e videoporteiros em Portugal. Instalação profissional sem mensalidades. Orçamentos gratuitos e personalizados.",
  keywords = "videovigilância portugal, alarmes ajax, videoporteiros, câmaras segurança, instalação cctv, sistemas segurança residencial, alarmes loja, videovigilância ip, segurança sem fios, orçamento segurança",
  canonicalUrl = "https://mercadotv.com",
  ogImage = "/logo.png",
  ogType = "website",
  structuredData = null,
  isProduct = false,
  productData = null
}) => {
  // Schema.org para produtos
  const productSchema = productData ? {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": productData.name,
    "description": productData.description,
    "image": productData.image,
    "brand": {
      "@type": "Brand",
      "name": "MercadoTV"
    },
    "offers": {
      "@type": "Offer",
      "price": productData.price,
      "priceCurrency": "EUR",
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "MercadoTV"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "reviewCount": "23"
    }
  } : null;

  // Schema padrão para páginas
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": canonicalUrl,
    "publisher": {
      "@type": "Organization",
      "name": "MercadoTV",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mercadotv.com/logo.png"
      }
    }
  };

  const schemaData = structuredData || productSchema || defaultSchema;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={`https://mercadotv.com${ogImage}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="MercadoTV" />
      <meta property="og:locale" content="pt_PT" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`https://mercadotv.com${ogImage}`} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      
      {/* Product-specific meta tags */}
      {isProduct && productData && (
        <>
          <meta property="product:price:amount" content={productData.price} />
          <meta property="product:price:currency" content="EUR" />
          <meta property="product:availability" content="in stock" />
        </>
      )}
    </Helmet>
  );
};

export default SEOHead;
